
const Sayfa = resolve => {
    require.ensure(['../views/apps/sayfa/Sayfa'], () => {
        resolve(require('../views/apps/sayfa/Sayfa'))
    })
};
const SayfaTanimlama = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaTanimla'], () => {
        resolve(require('../views/apps/sayfa/SayfaTanimla'))
    })
};

const SayfaListesi = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaListesi'], () => {
        resolve(require('../views/apps/sayfa/SayfaListesi'))
    })
};
const SayfaGuncelle = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaGuncelle'], () => {
        resolve(require('../views/apps/sayfa/SayfaGuncelle'))
    })
};
import Vue from 'vue'
Vue.component('SayfaTanimla', SayfaTanimlama);
Vue.component('SayfaListesi', SayfaListesi);
Vue.component('SayfaGuncelle', SayfaGuncelle);

import layouts from '../layout'

export default {
    path: '/sayfa',
    name: 'sayfa',
    component: Sayfa,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'sayfatanimlama',
            component: SayfaTanimlama,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'sayfaliste',
            component: SayfaListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'sayfaguncelle',
            component: SayfaGuncelle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
